import { SearchContextsEnum } from '../enums/search-contexts.enum';
import { SearchContextApiEnum } from '../../../api/mentions/enum/search-context-api.enum';

export const searchContextToApiMap = new Map<SearchContextsEnum, SearchContextApiEnum>([
    [SearchContextsEnum.body, SearchContextApiEnum.body],
    [SearchContextsEnum.header, SearchContextApiEnum.headline],
    [SearchContextsEnum.lead, SearchContextApiEnum.lead],
    [SearchContextsEnum.images, SearchContextApiEnum.image]
]);


export const searchContextFromApiMap = new Map<SearchContextApiEnum, SearchContextsEnum>([
    [SearchContextApiEnum.body, SearchContextsEnum.body],
    [SearchContextApiEnum.headline, SearchContextsEnum.header],
    [SearchContextApiEnum.lead, SearchContextsEnum.lead],
    [SearchContextApiEnum.image, SearchContextsEnum.images]
]);
